import { formatManagerPermissions } from 'shared/helpers';
import * as actionTypes from './actionTypes';

const initialState = {
  checkingUser: false,
  loading: true,
  details: {},
  company: {},
  customDomain: null,
  userSections: {},
  managerPermissionsLoading: true,
  managerPermissions: [],
  counter: [],
};

const initialSectionState = {
  loading: false,
  fetched: false,
  data: null,
  error: null,
  forbidden: false,
};

const getUpdatedUserSections = (state, userID, section, updates = {}) => {
  const currentUserSections = state.userSections[userID] || {};
  const currentSectionState =
    currentUserSections[section] || initialSectionState;

  return {
    ...state.userSections,
    [userID]: {
      ...currentUserSections,
      [section]: {
        ...currentSectionState,
        ...updates,
      },
    },
  };
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.loginInit:
      return {
        ...state,
        checkingUser: true,
      };
    case actionTypes.loginSuccess:
      return {
        ...state,
        details: action.user,
        company: action.user?.company || state.company,
        checkingUser: false,
      };
    case actionTypes.loginError:
      return {
        ...state,
        error: action.payload,
        checkingUser: false,
      };
    case actionTypes.logoutSuccess:
      return {
        ...state,
        details: {},
        company: {},
        userSections: {},
      };
    case actionTypes.logoutError:
      return {
        ...state,
        error: action.payload,
      };
    case actionTypes.getUserInit:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.getUserSuccess: {
      const permissions = Array.isArray(action.user?.permissions)
        ? action.user.permissions
        : state.details.permissions;
      const company =
        action.user?.company && typeof action.user.company === 'object'
          ? action.user.company
          : state.company;

      return {
        ...state,
        loading: false,
        company,
        details: {
          ...(action.user || {}),
          ...(Array.isArray(permissions) ? { permissions } : {}),
        },
      };
    }
    case actionTypes.getUserError:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.refreshUser:
      return {
        ...state,
        details: action.user,
        company: action.user?.company || state.company,
      };
    case actionTypes.setCustomDomainData:
      return {
        ...state,
        customDomain: action.data,
      };
    case actionTypes.getUserSectionInit:
      return {
        ...state,
        userSections: getUpdatedUserSections(
          state,
          action.payload.userID,
          action.payload.section,
          {
            loading: true,
            fetched: false,
            error: null,
            forbidden: false,
          },
        ),
      };
    case actionTypes.getUserSectionSuccess:
      return {
        ...state,
        company:
          action.payload.section === 'company' &&
          action.payload.data &&
          typeof action.payload.data === 'object'
            ? action.payload.data
            : state.company,
        userSections: getUpdatedUserSections(
          state,
          action.payload.userID,
          action.payload.section,
          {
            loading: false,
            fetched: true,
            data: action.payload.data,
            error: null,
            forbidden: false,
          },
        ),
      };
    case actionTypes.getUserSectionError:
      return {
        ...state,
        userSections: getUpdatedUserSections(
          state,
          action.payload.userID,
          action.payload.section,
          {
            loading: false,
            fetched: action.payload.forbidden,
            error: action.payload.error,
            forbidden: action.payload.forbidden,
          },
        ),
      };
    case actionTypes.getManagerPermissionsInit:
      return Object.assign({}, state, {
        managerPermissionsLoading: true,
      });
    case actionTypes.getManagerPermissionsSuccess: {
      const formattedPermissions = formatManagerPermissions(
        action.payload || [],
      );
      return Object.assign({}, state, {
        managerPermissionsLoading: false,
        managerPermissions: formattedPermissions,
        details: {
          ...state.details,
          permissions: formattedPermissions,
        },
      });
    }
    case actionTypes.getManagerPermissionsError:
      return Object.assign({}, state, {
        managerPermissionsLoading: false,
      });
    case actionTypes.getManagerCounterSuccess:
      return Object.assign({}, state, {
        counter: action.payload,
      });
    default:
      return state;
  }
}
